import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60f94ad4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "crm-item__left" }
const _hoisted_2 = { class: "crm-badge-text" }
const _hoisted_3 = { class: "crm-item__center" }
const _hoisted_4 = { class: "crm-item__title" }
const _hoisted_5 = { class: "crm-item__text" }
const _hoisted_6 = { class: "crm-item__right" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-plus" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: "crm-item__container",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('createContact', _ctx.emailAddressDetail)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.initials), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.emailAddressDetail?.displayName), 1),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.emailAddressDetail?.emailAddress), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_el_tooltip, {
        content: _ctx.$t('EmailAddressDetailsPreview.CreateContactTooltip'),
        placement: "top"
      }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      }, 8, ["content"])
    ])
  ]))
}